import { useEffect, useState } from "react";

/**
 * 1초마다 갱신되는 현재 시각(유닉스 밀리초)을 반환.
 * 서버 server_ts 와 비교해 실시간 카운트다운을 계산할 때 사용.
 */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);

  return now;
}